import { g as getWindow } from './getWindow-JtVpfBBJ.js';
import { g as getDocumentElement } from './getDocumentElement-CF55JRdX.js';
import { g as getWindowScrollBarX } from './getWindowScrollBarX-D_nS-TWC.js';
import { i as isLayoutViewport } from './isLayoutViewport-dvwbaDqh.js';

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

export { getViewportRect as g };
//# sourceMappingURL=getViewportRect-BlJjVXu2.js.map
